import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { addTestDeviceFetch } from '@/api/sandbox';
import { reportEvent } from '@/common';
import { message } from 'ant-design-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AddDeviceId',
  props: {
    modalVisible: {
      type: Boolean
    },
    dbtId: null
  },
  emits: ['update:modalVisible', 'updateList'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const rules = {
      deviceId: [{
        required: true,
        message: '请输入设备ID',
        trigger: 'blur'
      }]
    };
    const configForm = ref({
      deviceId: ''
    });
    const deviceRef = ref(null);
    const loading = ref(false); // loading状态
    const closeModal = () => {
      var _deviceRef$value;
      configForm.value = {
        deviceId: ''
      };
      (_deviceRef$value = deviceRef.value) === null || _deviceRef$value === void 0 || _deviceRef$value.resetFields();
      emit('update:modalVisible', false);
    };
    const handleOk = () => {
      deviceRef.value.validate().then(async () => {
        // 使用批量接口处理所有情况
        const params = {
          dbtId: props.dbtId,
          deviceId: configForm.value.deviceId
        };
        try {
          loading.value = true;
          const {
            code
          } = await addTestDeviceFetch(params);
          if (code === '0000') {
            message.success('添加成功');
            emit('updateList');
            closeModal();
            reportEvent({
              eventName: 'element_use',
              properties: {
                ui_name: '测试配置',
                element_name: '添加设备ID'
              }
            });
          }
        } catch (error) {} finally {
          loading.value = false;
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        title: "添加设备ID",
        centered: "",
        open: __props.modalVisible,
        onCancel: closeModal,
        onOk: handleOk,
        "confirm-loading": loading.value,
        "ok-text": "保存",
        width: "540px"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          model: configForm.value,
          layout: "vertical",
          ref_key: "deviceRef",
          ref: deviceRef,
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "设备ID",
            name: "deviceId",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: configForm.value.deviceId,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => configForm.value.deviceId = $event),
              valueModifiers: {
                trim: true
              },
              placeholder: "请输入设备ID"
            }, null, 8, ["value"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["open", "confirm-loading"]);
    };
  }
});